import * as createAccountYields from 'store/actions/account-yields/createAccountYields';
import * as deleteAccountYields from 'store/actions/account-yields/deleteAccountYields';
import * as fetchAccountYields from 'store/actions/account-yields/fetchAccountYields';
import * as updateAccountYields from 'store/actions/account-yields/updateAccountYields';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, select, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

const getAccountYieldStore = (state) => {
    return state.account_yields;
};

function* fetchAccountYieldsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/accounts/yielding`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchAccountYields.fetchAccountYieldsSuccess(response));
    } catch (error) {
        yield put(fetchAccountYields.fetchAccountYieldsFailure(error));
    }
}

function* fetchAccountYieldAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/accounts/yielding/${ payload.id }`;

        const response = yield apiClient.read(url);

        yield put(fetchAccountYields.fetchAccountYieldSuccess(response));
    } catch (error) {
        yield put(fetchAccountYields.fetchAccountYieldFailure(error));
    }
}

function* createAccountYieldAsync({ payload }) {
    const {
        callback,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/yielding`;

        const response = yield apiClient.create(url, values);

        yield put(createAccountYields.createAccountYieldSuccess(response));

        yield callback();
    } catch (error) {
        yield put(createAccountYields.createAccountYieldFailure(error));

        yield callback(error);
    }
}

function* createAccountYieldSuccessAsync() {
    yield put(showNotification('notifications.account_yields.create.success'));
}

function* updateAccountYieldAsync({ payload }) {
    const {
        callback,
        id,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/yielding/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateAccountYields.updateAccountYieldSuccess(id, response));

        yield callback();
    } catch (error) {
        yield put(updateAccountYields.updateAccountYieldFailure(error));

        yield callback(error);
    }
}

function* updateAccountYieldSuccessAsync() {
    yield put(showNotification('notifications.account_yields.update.success'));
}

function* deleteAccountYieldAsync({ payload }) {
    const { id } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/yielding/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteAccountYields.deleteAccountYieldSuccess(payload));
    } catch (error) {
        yield put(deleteAccountYields.deleteAccountYieldFailure(error));
    }
}

function* deleteAccountYieldSuccessAsync() {
    const getAccountYield = yield select(getAccountYieldStore);

    yield put(fetchAccountYields.fetchAccountYields({
        offset: getAccountYield.offset,
        page: getAccountYield.page,
    }));

    yield put(showNotification('notifications.account_yields.delete.success', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* AccountYieldsSagas() {
    yield [
        takeEvery(types.FETCH_ACCOUNT_YIELDS, fetchAccountYieldsAsync),
        takeEvery(types.FETCH_ACCOUNT_YIELDS_FAILURE, failureMessage),

        takeEvery(types.FETCH_ACCOUNT_YIELD, fetchAccountYieldAsync),
        takeEvery(types.FETCH_ACCOUNT_YIELD_FAILURE, failureMessage),

        takeEvery(types.CREATE_ACCOUNT_YIELD, createAccountYieldAsync),
        takeEvery(types.CREATE_ACCOUNT_YIELD_FAILURE, failureMessage),
        takeEvery(types.CREATE_ACCOUNT_YIELD_SUCCESS, createAccountYieldSuccessAsync),

        takeEvery(types.UPDATE_ACCOUNT_YIELD, updateAccountYieldAsync),
        takeEvery(types.UPDATE_ACCOUNT_YIELD_FAILURE, failureMessage),
        takeEvery(types.UPDATE_ACCOUNT_YIELD_SUCCESS, updateAccountYieldSuccessAsync),

        takeEvery(types.DELETE_ACCOUNT_YIELD, deleteAccountYieldAsync),
        takeEvery(types.DELETE_ACCOUNT_YIELD_FAILURE, failureMessage),
        takeEvery(types.DELETE_ACCOUNT_YIELD_SUCCESS, deleteAccountYieldSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/accountYieldsSagas.js